module.exports = __webpack_public_path__ + "static/img/comfirBtnGakhm.c7b68d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/comfirBtnGakhm.png
// module id = KGbv
// module chunks = 1